import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, ErrorHandler, Injector, NgModule } from '@angular/core';

import { OfficeHomeServiceWorkerAuthorizedInstallService } from '../service-worker/registration-handlers/officehome-service-worker-authorized-install.service';
import { SERVICE_WORKER_REGISTRATION_HANDLERS } from '../service-worker/registration-handlers/service-worker-registration-handlers.injection-token';
import { ApiConfigurationDataService } from '../shared/services/api-configuration-data.service';
import { ConfigParserService } from '../shared/services/config-parser.service';
import { WindowService } from '../shared/services/window.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { configDataServiceFactory, configParserServiceFactory, initializeAppShell } from './app-shell-config-parser-service.factory';
import { initializeShellClient } from './intialize-shell-client-from-appshell';

/**
 * NOTE: Be very careful adding service dependencies into this module. Since we will run this module in both the context of the AppShell mode and
 * non-AppShell mode, one most ensure services are instantiated at the correct time in initialization, since the two flows have different initialization
 * steps.
 */
@NgModule({
    providers: [
        // Conditionally provide the data service that drives the ApiConfigurationParser
        {
            provide: ApiConfigurationDataService,
            useFactory: configDataServiceFactory,
            deps: [ WindowService ]
        },
        // Provide a blocking promise to block bootstrap until the Shell and Config data has been resolved and places on the window
        // for synchronous access.
        {
            provide: APP_INITIALIZER,
            useFactory:
            initializeAppShell,
            deps: [ ApiConfigurationDataService ],
            multi: true
        },
        // Conditionally override the ConfigParserService to read from the Shell and Config data response, if in AppShell mode.
        {
            provide: ConfigParserService,
            useFactory: configParserServiceFactory,
            deps: [ ApiConfigurationDataService, ErrorHandler ]
        },
        // Conditionally initialize the Shell Client via client factory, only in AppShell mode.
        {
            provide: APP_BOOTSTRAP_LISTENER,
            useFactory: initializeShellClient,
            deps: [ Injector, ConfigParserService, ClientStartupConfigService ],
            multi: true
        },
        // Include an extra registration handle to post the Authorized Install information to the installing worker.
        // This is essentially ignored if not in AppShell mode.
        {
            provide: SERVICE_WORKER_REGISTRATION_HANDLERS,
            useClass: OfficeHomeServiceWorkerAuthorizedInstallService,
            multi: true
        }
    ]
})
export class OfficeHomeAppShellModule { }
